import * as types from '../actionTypes/annualReturnEmployee'

let defaultState = {
  annualReturnEmployees: []
}

const annualReturnEmployeetReducer = (state = defaultState, action) => {
  if (action.type === types.GET_EMPLOYEES_FOR_ANNUAL_RETURN) {
    return {
      ...state,
      annualReturnEmployees: action.annualReturnEmployees
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default annualReturnEmployeetReducer



// WEBPACK FOOTER //
// ./src/reducers/annualReturnEmployee.js